import { TextArea, TextAreaProps } from 'ui';
import React from 'react';
import { useField } from 'formik';

interface Props extends Omit<TextAreaProps, 'value' | 'onChange'> {
  name: string;
}

export const FormikTextArea: React.FC<Props> = ({ name, ...props }) => {
  const [field, meta] = useField(name);

  return <TextArea id={name} {...props} error={meta.error} {...field} />;
};
